import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/SolutionOverview.module.css';

const solutions = [
  {
    icon: '⚡',
    title: '간편 예약',
    description: '일일 대관뿐만 아니라 복잡한 정기 레슨도 상담 없이 앱으로 예약'
  },
  {
    icon: '🔄',
    title: '운영 자동화',
    description: '예약, 일정, 정산, 고객관리 전부 자동으로 돌아갑니다'
  },
  {
    icon: '📊',
    title: '데이터 기반 마케팅',
    description: '고객 행동 데이터를 보고 맞춤 쿠폰, 프로모션을 자동으로 발송'
  }
];

export default function SolutionOverview() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section id="solution" ref={ref} className={`section ${styles.solution}`}>
      <div className="section-content">
        <h2 className={`text-center ${styles.title}`}>
          <span className={styles.highlight}>올림</span>이 대신하는 세 가지
        </h2>
        <p className={`text-center ${styles.subtitle}`}>
          이제 운영 업무에 시간 쓰지 마세요. 올림이 대신합니다.
        </p>

        <div className={`${styles.cards} ${isVisible ? styles.visible : ''}`}>
          {solutions.map((item, index) => (
            <div
              key={index}
              className={styles.card}
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <span className={styles.icon}>{item.icon}</span>
              <h3 className={styles.cardTitle}>{item.title}</h3>
              <p className={styles.cardDesc}>{item.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
